import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import TokenReceiver from "@legacy/@gedesco/reactcomponentsgdc-v2.token-manager/TokenReceiver"
import { useImpuestoEmpresa } from "api/ImpuestoEmpresa.hook"
import { getUsuarioEmpresas } from "api/Usuario.service"
import { MODAL_STYLES } from "constants/primereactStyles"
import {
  fetchMiUsuarioYEmpresas,
  logout,
  manageLoginFromExternalApp,
} from "features/User/redux/slices/userSlice"
import UserService from "features/User/services/UserService"
import { useDispatch } from "hooks/useDispatch"
import { ProgressSpinner } from "primereact/progressspinner"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { ERP, LOGIN } from "routes/RoutePaths"

const userService = new UserService()

const SharedEntryPoint = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [authError, setAuthError] = useState(false)
  const [erorrTrack, setErrorTrack] = useState("")
  const messageReceived = useRef(false)
  const { impuestoEmpresaInvalidation } = useImpuestoEmpresa()

  const redirectToAccountsLogin = () => {
    window.location.replace(
      `${import.meta.env.REACT_APP_MY_ACCOUNT}${LOGIN}${ERP}`
    )
  }

  const onClose = () => {
    setAuthError(false)
    dispatch(logout())
    redirectToAccountsLogin()
  }

  const handleSharedEntryError = (message: $TSMigrationFixMe) => {
    setErrorTrack(message)
    setAuthError(true)
  }

  const setEmpresaActivaByNif = async (empresaNif: $TSMigrationFixMe) => {
    try {
      const { items: empresas } = await getUsuarioEmpresas()
      const empresaActivaFound = (empresas || []).find(
        ({ nif }) => nif === empresaNif
      )
      empresaActivaFound?.id &&
        (await userService.setEmpresaActiva(empresaActivaFound.id))
    } catch {
      handleSharedEntryError("#ERP_ETLI2")
    }
  }

  const OnPostLoginSuccess = async (empresaNif: $TSMigrationFixMe) => {
    try {
      empresaNif && setEmpresaActivaByNif(empresaNif)
      await impuestoEmpresaInvalidation()
      await dispatch(fetchMiUsuarioYEmpresas())
      history.push("/documentos/facturas")
    } catch {
      handleSharedEntryError("#ERP_ETLD3")
    }
  }

  const handleMessage = async (e: $TSMigrationFixMe) => {
    try {
      const data = e?.data?.value

      if (data && Object.keys(data || {}).length && !messageReceived.current) {
        const { token, refreshToken, empresaNif, isInterno } = data
        if (token) {
          messageReceived.current = true
          await dispatch(
            // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
            manageLoginFromExternalApp({
              token,
              refreshToken,
              empresaNif,
              isInterno,
              OnPostLoginSuccess,
              OnPostLoginError: handleSharedEntryError,
            })
          )
        }
      } else if (data && !Object.keys(data || {}).length) {
        handleSharedEntryError("#ERP_ETLD4")
      }
    } catch {
      handleSharedEntryError("#ERP_ETLD0")
    }
  }

  return (
    <>
      <TokenReceiver
        originUrl={import.meta.env.REACT_APP_ACCOUNTS}
        handleMessage={handleMessage}
      />
      <PrimeReactModal
        visible={authError}
        className='tw-w-128 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
        baseZIndex={30}
        ptContext={MODAL_STYLES}
        closable={false}
        footer={
          <div
            key='redirect'
            className='tw-px-4 tw-pb-1 tw-mt-3 tw-flex'
          >
            <ButtonPrimeReact
              label={`${t("sharedEntry.redirect")}`}
              className='tw-w-full tw-h-12 !tw-bg-primary tw-text-simple-10 tw-items-center'
              onClick={onClose}
            />
          </div>
        }
      >
        <>
          <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center tw-bg-simple-20 tw-mx-auto tw-mt-5 tw-mb-4'>
            <div className='tw-rounded-full tw-w-16 tw-h-16 tw-flex tw-justify-center tw-items-center tw-border tw-border-simple-90 tw-border-opacity-5 tw-bg-white tw-mx-auto'>
              <FontAwesomeIcon
                icon={["fal", "exclamation-triangle"]}
                className='tw-w-8 tw-h-8 tw-text-danger'
              />
            </div>
          </div>
          <div className='tw-text-2xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
            {t("sharedEntry.errorTitle")}
          </div>
          <div className='tw-w-full tw-flex tw-flex-col tw-text-base tw-px-4'>
            <p className='tw-mb-6 tw-text-center'>
              {t("sharedEntry.errorMessage")}
            </p>
            <p className='tw-text-center'>
              <i>
                <small>{`(${erorrTrack})`}</small>
              </i>
            </p>
          </div>
        </>
      </PrimeReactModal>
      {!authError && (
        <div className='tw-flex tw-justify-center tw-items-center spinner tw-w-screen tw-h-screen'>
          <ProgressSpinner />
        </div>
      )}
    </>
  )
}

export default SharedEntryPoint
